import { Navigate } from 'react-router-dom'
import { KnowQuestionnaire } from '../pages/data/KnowQuestionnaire'
import { useTabletContext } from './TabletLayout'

/**
 * `/tablet/data/:code` — el MISMO formulario del flujo personal
 * (`KnowQuestionnaire`, montado normalmente en `/data/:code`), pero adentro
 * del árbol del modo tablet. No es una copia: el componente se renderiza tal
 * cual y consume el outlet context de `TabletLayout`, que es un superset del
 * `KnowOutletCtx` que espera.
 *
 * Vive acá y no en `/data/:code` porque el auto-logout post-envío y el
 * watchdog de inactividad viven en `TabletLayout`: si el jugador saliera del
 * árbol `/tablet` para responder, la tablet se quedaría con su sesión abierta
 * (y con el chrome del área personal — perfil, resultados, "Salir" — a un
 * toque de distancia en un dispositivo compartido).
 *
 * La fase se chequea acá y no con un guard de auth: llegar por URL directa
 * sin haber pasado por el PIN y la confirmación de identidad manda de vuelta
 * al inicio del modo tablet.
 */
export function TabletQuestionnaire() {
  const { phase } = useTabletContext()
  if (phase !== 'questionnaire' && phase !== 'thanks') {
    return <Navigate to="/tablet" replace />
  }
  return <KnowQuestionnaire />
}
